export default __webpack_public_path__ + "static/media/MinerMk1.256.2dc0e697.png";